// File Metadata:
// Filename: NewShipmentFormPicture.js
// Version: 1.00
// Created: 2022-10-27 14:31:15
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

import {
	Alert,
	Button,
	ButtonGroup,
	Card,
	CardContent,
	CardHeader,
	IconButton,
	ImageList,
	ImageListItem,
	ImageListItemBar,
	Modal,
	Dialog,
	DialogContent
} from '@mui/material'
import { Box } from '@mui/system'
import React, { Component } from 'react'
import { nanoid } from 'nanoid'
import CameraIcon from '@mui/icons-material/Camera'
import RemoveCircle from '@mui/icons-material/RemoveCircle'
import Camera from '../../../components/Camera'
import CloseIcon from '@mui/icons-material/Close'

export class NewShipmentFormPicture extends Component {
	state = {
		errMsg: '',
		files: this.props.values.img || [],
		open: false
	}
	next = e => {
		e.preventDefault()
		if (this.state.files.length > 0) {
			this.props.handleValue('img', this.state.files)
			this.props.nextStep()
		} else {
			this.setState({ errMsg: 'You must take atleast one picture' })
		}
	}
	back = e => {
		e.preventDefault()
		this.props.prevStep()
	}

	handleCapture = photo => {
		const item = {
			img: photo,
			name: nanoid() + '.jpg',
			tags: [this.props.values.tour, this.props.values.sscc],
			size: Math.ceil(photo.length * 0.75), // Estimate file size from base64
			url: '',
			uploadProgress: 0
		}
		this.setState(prevState => ({
			files: [...prevState.files, item],
			open: false,
			errMsg: ''
		}))
	}

	handleCameraError = (errorMessage) => {
		this.setState({ 
			errMsg: errorMessage,
			open: false 
		})
		
		// Auto-retry for mobile devices
		if (/mobile/i.test(navigator.userAgent)) {
			setTimeout(() => {
				this.setState({ open: true, errMsg: '' })
			}, 1000)
		}
	}

	handleToggleCamera = () => {
		this.setState({ open: !this.state.open })
		if (this.state.errMsg) this.setState({ errMsg: '' })
	}

	onRemovePhoto = i => {
		const photos = this.state.files.filter((item, index) => index !== i)
		this.setState({ files: photos })
	}

	render() {
		return (
			<>
				<Card sx={{ minWidth: 200, boxShadow: 2, margin: 2 }}>
					<CardHeader
						title='Step 4: Upload picture'
						subheader='make a photo of the container with visible profiles'
					/>
					<CardContent>
						{this.state.errMsg && <Alert severity='error'>{this.state.errMsg}</Alert>}

						<Box sx={{ margin: 1 }}>
							<ImageList sx={{ maxWidth: 340 }} cols={2}>
								{this.state.files.map((item, i) => (
									<ImageListItem cols={1} rows={1} key={i}>
										<img src={`${item.img}`} alt='' />
										<ImageListItemBar
											sx={{
												background:
													'linear-gradient(to bottom, rgba(0,0,0,0.7) 0%, ' +
													'rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)'
											}}
											position='top'
											actionIcon={
												<IconButton
													sx={{ color: 'white' }}
													onClick={() => this.onRemovePhoto(i)}
												>
													<RemoveCircle />
												</IconButton>
											}
											actionPosition='right'
										/>
									</ImageListItem>
								))}
							</ImageList>
						</Box>
						<ButtonGroup fullWidth variant='contained' margin={1}>
							<Button onClick={this.back}>Back</Button>
							<Button onClick={this.handleToggleCamera}>
								<CameraIcon />
							</Button>
							<Button onClick={this.next}>Next</Button>
						</ButtonGroup>
					</CardContent>
				</Card>
				 <Dialog
                    open={this.state.open}
                    onClose={() => this.setState({ open: false })}
                    maxWidth="md"
                    fullWidth
                >
                    <DialogContent sx={{ p: 0, position: 'relative' }}>
                        <Camera 
                            onTakePhoto={this.handleCapture}
                            isImageMirror={false}
                            idealFacingMode="environment"
                        />
                        <IconButton
                            sx={{
                                position: 'absolute',
                                right: 8,
                                top: 8,
                                zIndex: 2,
                                color: 'white'
                            }}
                            onClick={() => this.setState({ open: false })}
                        >
                            <CloseIcon />
                        </IconButton>
                    </DialogContent>
                </Dialog>
			</>
		)
	}
}

const style = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: '90%',
	bgcolor: 'background.paper',
	border: '2px dashed #555',
	boxShadow: 6,
	p: 2
}

export default NewShipmentFormPicture
